import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function supplementaryContactVerificationSubmit(
  ccFormValue: Ref<FormCC>,
  page10Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  page10Overlay.value = true;
  const requestModel = {
    dropOffStep: "S13",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    suppWebFormRequestId: ccFormValue.value.supplementary.webFormRequestId,
    suppOtp: "false",
    webFormDetails: {
      supp: {
        isSupp: "No",
      },
    },
  };
  MasterService.pageSubmit(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        page10Overlay.value = false;
        ccFormValue.value.supplementary.webFormRequestId = "";
        ccFormValue.value.supplementary.question1 = "No";
        ccFormValue.value.supplementary.title = "";
        ccFormValue.value.supplementary.fullName = "";
        ccFormValue.value.supplementary.idType = "";
        ccFormValue.value.supplementary.idNo = "";
        ccFormValue.value.supplementary.nameOnCard = "";
        ccFormValue.value.supplementary.nationality = "";
        ccFormValue.value.supplementary.dob = "";
        ccFormValue.value.supplementary.gender = "";
        ccFormValue.value.supplementary.race = "";
        ccFormValue.value.supplementary.otherRace = "";
        ccFormValue.value.supplementary.motherMaidenName = "";
        ccFormValue.value.supplementary.relationship = "";
        ccFormValue.value.supplementary.email = "";
        ccFormValue.value.supplementary.mobileCountryCode = "";
        ccFormValue.value.supplementary.mobileNo = "";
        ccFormValue.value.supplementary.residentialAddress1 = "";
        ccFormValue.value.supplementary.residentialAddress2 = "";
        ccFormValue.value.supplementary.residentialAddress3 = "";
        ccFormValue.value.supplementary.postCode = "";
        ccFormValue.value.supplementary.city = "";
        ccFormValue.value.supplementary.state = "";
        jumpStep(12, "", "10");
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
    });
}
